<template>
    <!-- Footer -->
    <mdb-footer color="black" class="font-small">
<!--        <mdb-container class="text-left">-->
<!--            <mdb-row>-->
<!--                <mdb-col sm="6">-->
<!--                    <h5 class="title">Footer Content</h5>-->
<!--                    <p>Here you can use rows and columns here to organize your footer content.</p>-->
<!--                </mdb-col>-->
<!--                <mdb-col sm="6">-->
<!--                    <h5 class="title">Links</h5>-->
<!--                    <ul>-->
<!--                        <li class="list-unstyled"><a href="#!">Link 1</a></li>-->
<!--                        <li class="list-unstyled"><a href="#!">Link 2</a></li>-->
<!--                        <li class="list-unstyled"><a href="#!">Link 3</a></li>-->
<!--                        <li class="list-unstyled"><a href="#!">Link 4</a></li>-->
<!--                    </ul>-->
<!--                </mdb-col>-->
<!--            </mdb-row>-->
<!--        </mdb-container>-->
        <div class="footer-copyright text-center py-3 footer">
            <mdb-container fluid style="font-size: 12px">
                <p>Research was sponsored by the Army Research Laboratory and was accomplished under Cooperative Agreement Number W911NF-19-2-0112. The views and conclusions contained in this document are those of the authors and should not be interpreted as representing the official policies, either expressed or implied, of the Army Research Laboratory or the U.S. Government. The U.S. Government is authorized to reproduce and distribute reprints for Government purposes notwithstanding any copyright notation herein.</p>


                <!--                &copy; 2020 Copyright: <a href="https://www.wpi.edu/academics/study/data-science-ms"> WPI-ARC </a>-->
            </mdb-container>
        </div>
    </mdb-footer>
    <!-- Footer -->
</template>

<script>
    import { mdbFooter, mdbContainer, mdbRow, mdbCol } from 'mdbvue';
    export default {
        name: 'Footer',
        components: {
            mdbFooter,
            mdbContainer,
            // mdbRow,
            // mdbCol
        }
    }
</script>

<style scoped>
 footer{
     margin-top: 0!important;
 }
</style>